import { useEffect } from "react";

export const LAST_AUTH_CHANGE_KEY = "lastAuthChange";

/**
 * Record which user this browser is logged in as; pass undefined on logout.
 *
 * Other tabs reload only when the stored value changes. A login callback for
 * the same user writes the same value, which fires no storage event, so tabs
 * that re-authenticate after a reload do not reload each other. Logout writes
 * a fresh timestamped marker rather than removing the key, because removing a
 * key that is already absent fires no storage event.
 */
export const recordAuthChange = (userId: string | undefined): void => {
    if (userId === undefined) {
        localStorage.setItem(LAST_AUTH_CHANGE_KEY, `logged-out:${Date.now()}`);
    } else {
        localStorage.setItem(LAST_AUTH_CHANGE_KEY, userId);
    }
};

export const useReloadOnAuthChangeInOtherTab = (): void => {
    useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (
                event.key === LAST_AUTH_CHANGE_KEY &&
                event.newValue !== event.oldValue
            ) {
                window.location.reload();
            }
        };
        window.addEventListener("storage", onStorage);
        return () => {
            window.removeEventListener("storage", onStorage);
        };
    }, []);
};
